<template>
  <div class="flex flex-col" :style="styles">
    <div
      class="w-full min-h-[50px] tablet-h:min-h-[60px] flex items-center justify-center font-secondary relative"
    >
      <Icon
        v-if="showBackButton"
        name="ChevronUp"
        class="-rotate-90 stroke-gray-800 absolute left-1.5 cursor-pointer"
        :size="30"
        @click="onboardingStore.goToPrevStep"
      />

      <DacrWordLogo class="h-[26px] desktop:h-[30px]" />
    </div>

    <div class="flex flex-grow overflow-hidden" :style="containerStyles">
      <RouterView class="overflow-auto" :style="routerStyles" />
    </div>
  </div>
</template>

<script setup lang="ts">
import DacrWordLogo from '@/assets/svg/other/DacrWordLogo.svg'
import { computed, watchEffect } from 'vue'
import { useDevice } from '@/shared/composables/useDevice'
import { Icon } from '@dacr/ui'
import { useOnboardingStore } from '@/features/onboarding/store'
import { useRoute, useRouter } from 'vue-router'
import { NativeActionsEnum, useWebviewStore } from '@/shared/stores/webview'
import {
  useOnboardingQuery,
  usePlansQueryQuery,
} from '@/shared/graphql/legacy/generated'
import { getTokens } from '@dacr/auth'

const _ = usePlansQueryQuery({ accessToken: getTokens().accessToken })

const { result } = useOnboardingQuery()

const device = useDevice()
const router = useRouter()
const route = useRoute()
const onboardingStore = useOnboardingStore()
const webviewStore = useWebviewStore()

watchEffect(() => {
  if (!result.value?.onboarding.completed) return

  if (webviewStore.isActive) {
    return webviewStore.postMessage({
      type: NativeActionsEnum.NavigationHome,
    })
  }

  router.push('/home')
})

const styles = computed(() => ({
  ...(webviewStore.isActive && {
    height: `${device.viewportHeight.value}px`,
    paddingTop: `${webviewStore.topSafeAreaHeight}px`,
  }),
}))

const containerStyles = computed(() => {
  const navbarHeight =
    device.isMobile.value || device.isTabletVertical.value ? 50 : 60

  return {
    height: `${device.viewportHeight.value - navbarHeight - webviewStore.topSafeAreaHeight}px`,
  }
})

const routerStyles = computed(() => ({
  ...(webviewStore.isActive && {
    paddingBottom: `${22 + webviewStore.bottomSafeAreaHeight}px`,
  }),
  ...(!webviewStore.isActive && {
    paddingBottom: device.isDesktop.value ? '70px' : '22px',
  }),
}))

const showBackButton = computed(
  () => onboardingStore.step > 1 && route.path === '/onboarding'
)
</script>
